import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../__styling'

export const StyledButtonGroup = styled('div')(({ theme }) => [
    {
        display: 'flex',
        justifyContent: 'end',
    },
    // PerthNow Styling
    theme.kind === 'perthnow' && {
        display: 'inline-flex',
        flexDirection: 'column-reverse',
        width: '100%',
        gap: calcRem(8),

        [breakpoint('sm')]: {
            flexDirection: 'row',
            gap: calcRem(12),
        },
    },
])
